import type { Dispatch, SetStateAction } from "react"
import { faCircleExclamation } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Button, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    root: {
        paddingBottom: "1rem",
    },
    row: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "0.5rem",
    },
    icon: {
        color: "#f58891",
        paddingRight: "0.5rem",
    },
    textButton: {
        textTransform: "none",
    },
}))

type TableToolbarBannerProps = Readonly<{
    showNotPrintedOrders: boolean
    setShowNotPrintedOrders: Dispatch<SetStateAction<boolean>>
}>

export function TableToolbarBanner({ showNotPrintedOrders, setShowNotPrintedOrders }: TableToolbarBannerProps) {
    const { classes } = useStyles()

    return (
        <Box className={classes.root}>
            <Box className={classes.row}>
                <FontAwesomeIcon icon={faCircleExclamation} size="xl" className={classes.icon} />

                {!showNotPrintedOrders ? (
                    <>
                        <LocalizedStrict id="production-table-toolbar-banner-unprinted-receipts-message">
                            <Typography component="span">Receipts not printed on the cloud printer.</Typography>
                        </LocalizedStrict>

                        <LocalizedStrict id="production-table-toolbar-banner-show-button">
                            <Button
                                onClick={() => setShowNotPrintedOrders(true)}
                                variant="text"
                                className={classes.textButton}
                            >
                                Show
                            </Button>
                        </LocalizedStrict>
                    </>
                ) : (
                    <>
                        <LocalizedStrict id="production-table-toolbar-banner-showing-unprinted-message">
                            <Typography component="span">Showing unprinted orders.</Typography>
                        </LocalizedStrict>

                        <LocalizedStrict id="production-table-toolbar-banner-clear-filter-button">
                            <Button
                                onClick={() => setShowNotPrintedOrders(false)}
                                variant="text"
                                className={classes.textButton}
                            >
                                Clear filter
                            </Button>
                        </LocalizedStrict>
                    </>
                )}
            </Box>
        </Box>
    )
}
